









import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

@Component({
    computed: {
        ...mapGetters({
            unitLink: 'StaffProperties/getStaffPropertyIconLink',
        }),
    },
})
export default class StaffUnitButton extends Vue {
    constructor() {
        super();
    }

    public gotToUnit(id: number) {
        this.$router.push({ path: `/user/units/${id}` });
    }
}
